import { ArrayParam, useQueryParams } from "use-query-params";
import { usePagination, useSearch, useSorting } from "@/hooks";
import { GetExternalSuppliersParams } from "@/redux/apis/externalSupplier/types";

const FilterParams = {
  type: ArrayParam,
  status: ArrayParam,
  state: ArrayParam,
  rating: ArrayParam,
};

export const useGetExternalSuppliersParams = () => {
  const { page, pageSize } = usePagination();
  const { sorting, setSorting, sortKey, direction } = useSorting();
  const [filters, setFilters] = useQueryParams(FilterParams);
  const [search, setSearch] = useSearch();

  const params: GetExternalSuppliersParams = {
    page,
    page_size: pageSize,
    sort: sortKey,
    direction,
    search,
    type: filters.type ? (filters.type.filter(Boolean) as string[]) : undefined,
    account_status: filters.status ? (filters.status.filter(Boolean) as string[]) : undefined,
    address_state: filters.state ? (filters.state.filter(Boolean) as string[]) : undefined,
    rating: filters.rating ? (filters.rating.filter(Boolean) as string[]) : undefined,
  };

  return {
    params,
    sorting,
    setSorting,
    sortKey,
    direction,
    filters: {
      type: params.type,
      accountStatus: params.account_status,
      addressState: params.address_state,
      rating: params.rating,
    },
    setFilters,
    search,
    setSearch,
  };
};
